import type { FaireProductEntity } from "../../entity_types/product";

export const p_8ku59wyqh3: FaireProductEntity = {
  token: "p_8ku59wyqh3",
  type: "product",
  name: "Pink Tourmaline Beads x Turquoise Star Necklace",
  brandToken: "b_962fea69",
  brandName: "Anna Beck Jewelry | Handmade in Bali",
  imageUrl:
    "https://cdn.faire.com/fastly/9d0e466ac97fecca2da10a70c4d9b65a29fe4cc5083b6a2318093f1858102c79.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1fde981096e2ce460cab6799136a31069bfc8adb7ff622e3ca40a63b8c7e68da.jpeg",
    "https://cdn.faire.com/fastly/722e4c8d6b881e7a03963a241cefe4c6eae47f395f23cdc8a04e3a086479646d.jpeg",
  ],
  priceDollars: 151,
  description:
    'This necklace pairs vibrant pink tourmaline beads with a stunning turquoise star pendant for an offering made for year round color-lovers.\n\nPRODUCT DETAILS:\n\n * Handmade in Bali \n * 18k gold plated over sterling silver \n * Necklace length: adjustable 16-18" \n * Bead size: 4mm \n * Stone size: 15mm \n * Turquoise is the stone of protection, wisdom, and clear communication \n * Tourmaline is the stone of compassion, balance, and emotional healing ',
  tags: [],
  msrpDollars: 354.85,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:46.876Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
